<div class="bank-dialog-backdrop" *ngIf="visible" (click)="close()">
  <section class="bank-dialog" role="dialog" aria-modal="true" aria-label="Cập nhật tài khoản ngân hàng" (click)="$event.stopPropagation()">
    <div class="bank-dialog-header">
      <h3>Thông tin tài khoản ngân hàng</h3>
      <button type="button" class="bank-close-btn" (click)="close()" aria-label="Đóng">×</button>
    </div>

    <div class="bank-current-info">
      <h4>Thông tin hiện tại</h4>
      <div class="bank-info-grid">
        <div><span class="label">Chủ TK:</span> <strong>{{ userInfo?.bankAccountName || 'Chưa có' }}</strong></div>
        <div><span class="label">Ngân hàng:</span> <strong>{{ userInfo?.bankName || 'Chưa có' }}</strong></div>
        <div><span class="label">Chi nhánh:</span> <strong>{{ userInfo?.bankBranch || 'Chưa có' }}</strong></div>
        <div><span class="label">Số TK:</span> <strong>{{ userInfo?.bankAccountNumber || 'Chưa có' }}</strong></div>
        <div><span class="label">Số dư:</span> <strong>{{ currentBalanceDisplay }}đ</strong></div>
      </div>
    </div>

    <div class="bank-update-form" *ngIf="!hasBankInfo">
      <h4>Thông tin thay đổi</h4>

      <label class="required-label" for="bank-account-name">Tên chủ tài khoản</label>
      <input id="bank-account-name" name="bankAccountName" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="draftBankAccountName" placeholder="Nhập tên chủ tài khoản" [disabled]="hasBankInfo" />

      <label class="required-label" for="bank-name">Tên ngân hàng</label>
      <ng-container *ngIf="!banksLoading && banks.length; else bankNameFallback">
        <select id="bank-name" name="bankName" [(ngModel)]="draftBankName" [disabled]="hasBankInfo">
          <option value="">-- Chọn ngân hàng --</option>
          <option *ngFor="let b of banks" [value]="b.shortName">{{ b.shortName }} - {{ b.name }}</option>
        </select>
      </ng-container>
      <ng-template #bankNameFallback>
        <input
          id="bank-name"
          name="bankName"
          type="text"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          [(ngModel)]="draftBankName"
          [placeholder]="banksLoading ? 'Đang tải danh sách ngân hàng...' : 'VD: Vietcombank'"
          [disabled]="banksLoading || hasBankInfo"
        />
      </ng-template>

      <label for="bank-branch">Chi nhánh</label>
      <input id="bank-branch" name="bankBranch" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="draftBankBranch" placeholder="VD: CN Hà Nội" [disabled]="hasBankInfo" />

      <label class="required-label" for="bank-account-number">Số tài khoản</label>
      <input id="bank-account-number" name="bankAccountNumber" type="text" inputmode="numeric" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="draftBankAccountNumber" placeholder="Nhập số tài khoản" maxlength="12" [disabled]="hasBankInfo" />

      <label class="required-label" for="bank-withdraw-password">Mật khẩu rút tiền</label>
      <input id="bank-withdraw-password" name="withdrawPasswordBank" type="password" autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="draftpasswordBank" placeholder="Nhập mật khẩu rút tiền" [disabled]="hasBankInfo" />

      <div class="bank-submit-error" *ngIf="submitError">{{ submitError }}</div>

      <div class="bank-actions">
        <button type="button" class="button close-button" (click)="close()">Đóng</button>
        <button type="button" class="save-button" (click)="save()" [disabled]="hasBankInfo">Lưu thay đổi</button>
      </div>
    </div>
  </section>
</div>
